import * as React from 'react';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { Spinner } from 'ui/shapes';

import './Loading.css';

export type LoaderSize = 'tiny' | 'small' | 'large' | 'xlarge';

export type OwnProps = {
    textKey?: string;
    size: LoaderSize;
    centered?: boolean;
};

const propsBySize = {
    tiny: {
        width: '16px',
        height: '16px',
    },
    small: {
        width: '32px',
        height: '32px',
    },
    large: {
        width: '64px',
        height: '64px',
    },
    xlarge: {
        width: '128px',
        height: '128px',
    },
};

export const RawLoading = ({ size, textKey, centered = true, t, styles }: OwnProps & TranslateProps & OemProps) =>
    <span className={ `loading ${centered ? 'centered' : ''}` }>
        <Spinner
            { ...propsBySize[size] }
            style={ styles.FillForeground }
        />
        { textKey &&
            <span
                className="loading-text"
                style={ styles.FillForeground }
            >
                { t(textKey) }
            </span>
        }
    </span>
;

export const Loading = compose<OwnProps & TranslateProps & OemProps, OwnProps>(
    skin,
    translate(),
)(RawLoading);



// WEBPACK FOOTER //
// ./src/ui/shared/Loading.tsx